import React, { PropTypes } from 'react';
import Input from '../../form/Input';
import RaisedButton from 'material-ui/RaisedButton';

class ClubEditForm extends React.Component {
  static propTypes = {
    save: PropTypes.func.isRequired
  };

  save(data) {
    return this.props.save(Object.assign(this.props.model, data));
  }

  render() {
    let {
          fields: { name },
          handleSubmit,
          submitting
        } = this.props;

    return (
      <form onSubmit={() => {handleSubmit(data => this.save(data))}}>
        <Input label="Name" type="text" required {...name} />

        <RaisedButton label="Save" accent primary disabled={submitting} type="submit"/>
        <RaisedButton label="Cancel" type="button"/>
      </form>
    );
  }
}

export default ClubEditForm;



// WEBPACK FOOTER //
// ./src/components/Clubs/ClubEditForm/ClubEditForm.jsx